import { isSingles } from "../../utils/categoriesMap";

export const composeEmptyPlayers = (category: string) => {
  const player = {
    name: null,
    nationality: "",
    seed: "",
  };
  return isSingles(category) ? [player] : Array(2).fill(player);
};